import { DBButton } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";

type REDButtonProps = ComponentProps<typeof DBButton>;

const REDButton: React.FC<REDButtonProps> = (props) => {
    return <DBButton {...props}>{props.children}</DBButton>;
};

export default REDButton;